import { ref, watch } from 'vue'
import { useFrontEndDataQuery } from '../queries/useFrontEndDataQuery'
import { DropdownOption } from '@/api/contracts/models'

export function useDevices() {
   const { data: frontendData } = useFrontEndDataQuery()
   const result = ref<undefined | DropdownOption[]>(undefined)

   const setDevices = () => {
      result.value = frontendData.value!.devices
   }

   watch(
      [frontendData],
      () => {
         if (frontendData.value) {
            setDevices()
         }
      },
      { immediate: true, deep: true }
   )

   return result
}
